module.exports = __webpack_public_path__ + "media/images/fr_private_corner_pres_still-2755c8f5.jpg";